export default class AjaxAction {

    /**
     * Timeout para ocultar la accion actual
     * @type {null}
     */
    hideTimeout = null;

    /**
     * Para mostrar los mensajes del log
     * @type {boolean}
     */
    debug =  true;

    /**
     * Logea, si esta activo, el mensaje
     * @param msg
     */
    log(msg){
        if(this.debug) {
            console.log("AjaxAction: "+msg);
        }
    }

    loading(){
        this.log("loading()");
        var me = this;

        if(me.hideTimeout!==null) {
            clearTimeout(me.hideTimeout);
        }
        $("#ajax-actions").removeClass("success").removeClass("error").removeClass("saving");
        $("#ajax-actions").addClass("show").addClass("loading");
    }

    success(){
        this.log("success()");
        var me = this;

        if(me.hideTimeout!==null) {
            clearTimeout(me.hideTimeout);
        }
        $("#ajax-actions").removeClass("error").removeClass("loading").removeClass("saving");
        $("#ajax-actions").addClass("show").addClass("success");
        me.hideTimeout = setTimeout(function(){
            me.hide();
        }, 1250);
    }

    error(){
        this.log("error()");
        var me = this;

        if(me.hideTimeout!==null) {
            clearTimeout(me.hideTimeout);
        }
        $("#ajax-actions").removeClass("success").removeClass("loading").removeClass("saving");
        $("#ajax-actions").addClass("show").addClass("error");
        this.hideTimeout = setTimeout(function(){
            me.hide();
        }, 1250);
    }

    saving(){
        this.log("saving()");
        var me = this;

        if(me.hideTimeout!==null) {
            clearTimeout(me.hideTimeout);
        }
        $("#ajax-actions").removeClass("success").removeClass("error").removeClass("loading");
        $("#ajax-actions").addClass("show").addClass("saving");
    }

    hide(){
        this.log("hide()");
        var me = this;

        $("#ajax-actions").removeClass("show");
    }


    initEvents() {
        this.log("initEvents()");
        var me = this;

        var html = '<div id="ajax-actions" class="loading">';
        html += '<div class="error"><i class="fa fa-exclamation-triangle"></i> Error</div>';
        html += '<div class="loading"><i class="fa fa-spinner fa-spin"></i> Cargando...</div>';
        html += '<div class="success"><i class="fa fa-check"></i> Completado</div>';
        html += '<div class="saving"><i class="fa fa-save fa-beat"></i> Guardando...</div>';
        html += '</div>';

        $("body").append(html);
    }

}